import { useQuery, UseQueryResult } from 'react-query';
import { getLatestExposure, ExposureSnapshot } from '../services/exposureService';

/**
 * Fetch the latest exposure snapshot per formula + overall for an account.
 * Returns raw ExposureSnapshot[] with full breakdown data and createdAt timestamp.
 */
export function useLatestExposure(
  accountId: string | number | undefined,
  enabled = true,
): UseQueryResult<ExposureSnapshot[], Error> {
  const numericId = typeof accountId === 'string' ? parseInt(accountId) : accountId;

  return useQuery(
    ['latestExposure', numericId],
    () => getLatestExposure(numericId),
    {
      enabled: enabled && !!numericId,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}
